import date from 'element-ui/lib/utils/date'
export function formatTime(time, option) {
  if (!time) {
    return '--'
  }
  if (typeof time !== 'object') {
    if (('' + time).length === 10) time = parseInt(time) * 1000
  }
  return date.format(Number(time), option)
}
